// IssueViewerRedirect — /issue-viewer/:issueId → /issue/:shareToken.
//
// Backend notification links (back/utils/notify callers) and the new
// coordination surfaces address issues by _id, but the real viewer
// route is /issue/:shareToken. This tiny page resolves the id via
// GET /issue/id/:id and replaces the URL with the share-token route.
import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Skeleton, Button } from "antd";
import { getIssueById } from "api/issue/issueApi";

export default function IssueViewerRedirect() {
  const { issueId } = useParams();
  const history = useHistory();
  const [err, setErr] = useState(null);

  useEffect(() => {
    let alive = true;
    getIssueById(issueId)
      .then((res) => {
        if (!alive) return;
        // GET /issue/id/:id responds {data: issue, permission, isOwner}
        const issue = res?.data || res?.issue || res;
        if (issue?.shareToken) {
          history.replace(`/issue/${issue.shareToken}/resolve`);
        } else {
          setErr("This issue has no share link yet.");
        }
      })
      .catch((e) => {
        if (alive) setErr(e.message || "Issue not found");
      });
    return () => {
      alive = false;
    };
  }, [issueId, history]);

  if (err) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        <h3>Could not open issue</h3>
        <p style={{ color: "#888" }}>{err}</p>
        <Button onClick={() => history.push("/issues")}>Go to Issues Manager</Button>
      </div>
    );
  }
  return (
    <div style={{ padding: 40 }}>
      <Skeleton active paragraph={{ rows: 6 }} />
    </div>
  );
}
